/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * This class is used for encapsulating the data while building the grid info and calculating dates
 */
export class ProgramTiming {
    projectName: string;
    adjustedWeeks: number;
    date: Date;
    needsDateFromSecondLoop: boolean;
    within30Days: boolean;
    within60Days: boolean;
    within90Days: boolean;
    icdsNotOnSchedule: number;
    icdsNotOnScheduleLink: string;
    // True when a user typed this date directly (blank ICDe Stage rows in Create Timing).
    // Manual dates are fixed absolute dates and are protected from recalculation.
    manualDateEntered?: boolean;
    // True when this ECS date was copied from a matching PROD timing (AC3/AC4).
    inheritedFromProd?: boolean;

    constructor() {
        this.adjustedWeeks = 0;
    }

    /**
     * Timing dates are stored as timestamp-without-time-zone (treated as GMT).
     * Jackson from a UTC JVM emits UTC midnight; add the client offset so the
     * calendar day matches what the user saved. Do not change this formula
     * without also changing the save-path -timezoneOffset shift.
     */
    static shiftServerDateToLocal(date: Date | string | number): Date {
        const shifted = new Date(date);
        shifted.setMinutes(shifted.getMinutes() + shifted.getTimezoneOffset());
        return shifted;
    }

    setDataFromProgramTimingRow(row: ProgramTiming) {
        this.adjustedWeeks = row.adjustedWeeks;
        // adjust the date of the saved program timing because a different time zone
        // between server and client can shift this date incorrectly
        this.date = row.date ? ProgramTiming.shiftServerDateToLocal(row.date) : row.date;
        this.projectName = row.projectName;
        this.icdsNotOnSchedule = row.icdsNotOnSchedule;
        this.icdsNotOnScheduleLink = row.icdsNotOnScheduleLink;
    }
}
